import React, { Suspense } from "react";

import { Redirect } from "react-router";
import { useLocation } from "react-router-dom";
import LoadingOverlay from "components/LoadingOverlay";
import { selectAuth } from "redux/slices/authSlice";
import { useTypedSelector } from "redux/hooks";

interface Props {
  children: React.ReactNode;
  forceAccessToken?: boolean;
}

const AuthLayout = ({ children, forceAccessToken }: Props) => {
  const { accessToken, refreshToken } = useTypedSelector(selectAuth);
  const location = useLocation();

  if (!accessToken && !forceAccessToken && !refreshToken)
    return (
      <Redirect to={{ pathname: "/", state: { from: location.pathname } }} />
    );

  return <Suspense fallback={<LoadingOverlay />}>{children}</Suspense>;
};

export default AuthLayout;
